module.exports = __webpack_public_path__ + "static/media/CC-SPL1_1Bl2JjkwD6Ygn8kprhhVIXoJ6PIR3pXck.c6ddd8f3.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-SPL1_1Bl2JjkwD6Ygn8kprhhVIXoJ6PIR3pXck
// module id = 792
// module chunks = 0